import React from 'react';

export default function Footer(props) {
  // const linkTeal = useColorModeValue("teal.400", "red.200");=
  return '';
}
